import { render, staticRenderFns } from "./chatImage.vue?vue&type=template&id=50f46fe1&"
import script from "./chatImage.vue?vue&type=script&lang=js&"
export * from "./chatImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports